var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:({ width: _vm.imageWidth + 'px', height: _vm.imageHeight + 'px' }),attrs:{"type":"button"},on:{"click":_vm.toggleZoom}},[_c('frame-image',{staticClass:"zoom-image__frame",attrs:{"pose":_vm.pose}}),_c('zoom-image',{staticClass:"zoom-image__img",attrs:{"pose":_vm.pose,"src":_vm.src,"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }